import React, { FC } from "react"
import styled from "@emotion/styled"
import { SectionTitle, Subtitle, ParagraphSmall } from "@/components/Content"
import { useTranslation } from "react-i18next"
import { mobileFirstDevice } from "@/utils/media-queries"
import Section from "@/components/Section"
import OfficeGallery from "./OfficeGallery"
import { Row, Col } from "react-grid-system"
import { css } from "@emotion/css"

//padding: 535px 24px 200px;
const Wrapper = styled(Row)`
  width: 100%;
  text-align: left;

  @media ${mobileFirstDevice.laptop} {
    margin-bottom: 110px;
  }
`

const Title = styled(SectionTitle)`
  text-align: left;
  padding: 170px 0 70px 0;
  color: ${({ theme }) => theme.colors.black};

  @media ${mobileFirstDevice.tablet} {
    font-size: 34px;
    padding: 90px 0 30px 0;
  }

  @media ${mobileFirstDevice.laptop} {
    font-size: 64px;
    padding: 180px 0 100px 0;
  }
`

const StyledSubtitle = styled(Subtitle)`
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: 24px;
  letter-spacing: 0;
`

const Content = styled(ParagraphSmall)`
  margin-bottom: 80px;
`

const CommentPic = styled.div<{ isLongText?: boolean }>`
  width: 156px;
  margin-bottom: 28px;
  position: relative;

  @media ${mobileFirstDevice.tablet} {
    width: 95px;
    position: absolute;
    top: ${({ isLongText }) => (isLongText ? "-100px" : "-140px")};
  }

  @media ${mobileFirstDevice.laptop} {
    width: 182px;
    margin-left: 180px;
    top: ${({ isLongText }) => (isLongText ? "-160px" : "-238px")};
  }
`

const Comment = styled.div<{ isLongText?: boolean }>`
  white-space: pre-wrap;
  position: relative;
  font-weight: 300;
  font-size: 24px;
  line-height: 125%;
  letter-spacing: -0.015em;
  color: ${({ theme }) => theme.colors.hightlightTextLightBg};
  padding-left: 12px;
  &:before {
    content: '"';
    position: absolute;
    top: 0;
    left: 2px;
  }

  &: after {
    content: '"';
  }

  @media ${mobileFirstDevice.tablet} {
    position: absolute;
    font-size: 30px;
    top: ${({ isLongText }) => (isLongText ? "10px" : "-30px")};
    width: 392px;
  }

  @media ${mobileFirstDevice.laptop} {
    top: ${({ isLongText }) => (isLongText ? "20px" : "-50px")};
    margin-left: 180px;
    width: 620px;
    font-size: 48px;
    padding-left: 0;

    &:before {
      left: -22px;
    }
  }
`

const CommentContainer = styled.div`
  height: 365px;

  @media ${mobileFirstDevice.tablet} {
    height: 195px;
  }

  @media ${mobileFirstDevice.laptop} {
    height: 510px;
  }
`

const WorkingSection: FC = () => {
  const { t, i18n } = useTranslation("careers")
  const longText = ["fr", "hu", "id", "pl", "ru"] //https://mcoproduct.atlassian.net/browse/BM-2284

  return (
    <Section
      light
      TitleComponent={() => (
        <Title
          dangerouslySetInnerHTML={{
            __html: t("working.title").replace(/\n/g, "<br />"),
          }}
        />
      )}
      alignTitle="left"
    >
      <Row
        className={css`
          width: 100%;
          text-align: left;

          @media ${mobileFirstDevice.laptop} {
            margin-bottom: 110px;
          }
        `}
        justify="center"
        gutterWidth={20}
      >
        <Col xs={12} md={6}>
          <StyledSubtitle
            dangerouslySetInnerHTML={{
              __html: t("working.empowered").replace(/\n/g, "<br />"),
            }}
          />
          <Content>
            <span
              dangerouslySetInnerHTML={{
                __html: t("working.talent").replace(/\n/g, "<br />"),
              }}
            />
          </Content>
        </Col>
        <Col xs={12} md={6}>
          <OfficeGallery />
        </Col>
      </Row>
    </Section>
  )
}

export default WorkingSection
